import React from 'react';
import { ISaleLabelProps, SaleLabel } from '@secretescapes/cauldron';
import { BadgeType, BadgeVariant } from '@secretescapes/falcon';
import { partition } from '@utils/lodash.utils';

interface IBadges {
  badges: ISaleLabelProps[];
  isMobile?: boolean;
}

export const Badges = ({ badges, isMobile }: IBadges) => {
  if (!badges.length) {
    return null;
  }

  const [promoBadges, infoBadges] = partition(badges, ['type', BadgeType.PROMOTIONAL]);

  const sortedPromoBadges = promoBadges.sort((a, b) => a.priority - b.priority);

  const filteredBadges =
    sortedPromoBadges.length > 0 ? [sortedPromoBadges[0], ...infoBadges] : [...infoBadges];

  return (
    <>
      {filteredBadges.map((badge, i) => {
        const { backgroundColor, icon, saleLabelTranslations, fontColor, priority, type } = badge;

        return (
          <SaleLabel
            disableTouch={false}
            key={`${saleLabelTranslations?.translatedLabelValue}_${icon}_${i}`}
            backgroundColor={backgroundColor}
            icon={icon}
            saleLabelTranslations={saleLabelTranslations}
            saleLabelVariant={isMobile ? BadgeVariant.normal : BadgeVariant.large}
            fontColor={fontColor}
            priority={priority}
            type={type}
            emboldened={type === BadgeType.INFORMATIONAL}
          />
        );
      })}
    </>
  );
};
